<template>
    <div class="col-span-12 lg:col-span-10">
        <page-header class="mb-2 md:mb-2">
            <slot name="page-header">Users</slot>
        </page-header>

        <vx-tabs v-if="showTabs" v-model="currentTab" size="lg" class="mb-8">
            <vx-tab value="active">Active</vx-tab>
            <vx-tab value="pending">
                <span class="relative">
                    Pending
                    <span class="absolute -inset-e-1.5 inset-bs-0 bg-sky-500 w-1.5 h-1.5 rounded-full"></span>
                </span>
            </vx-tab>
        </vx-tabs>

        <org-unit-active-users
            v-show="currentTab === 'active'"
            ref="activeUsersRef"
            :orgUnitId="props.orgUnitId"
            :orgUnitName="props.orgUnitName"
            :teamId="props.teamId"
            :canManageUsers="props.canManageUsers"
            :requireSso="props.requireSso"
            @added="onAdded"
            @updated="onUpdated"
            @invited="onInvited"
        ></org-unit-active-users>
        <org-unit-pending-users
            v-show="currentTab === 'pending'"
            ref="pendingUsersRef"
            :orgUnitId="props.orgUnitId"
            :orgUnitName="props.orgUnitName"
            :teamId="props.teamId"
            :canManageUsers="props.canManageUsers"
            :totalCount="invitesCount"
            @added="onAdded"
            @updated="onUpdated"
            @invited="onInvited"
            @deleted="onInviteDeleted"
        ></org-unit-pending-users>
    </div>
</template>
<script setup>
import { VxTabs, VxTab } from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import { orgUnitInvitationsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';
import OrgUnitActiveUsers from './OrgUnitActiveUsers.vue';
import OrgUnitPendingUsers from './OrgUnitPendingUsers.vue';
import { ref } from 'vue';

const toasted = useToasted();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
    orgUnitName: {
        type: String,
        default: '',
    },
    canManageUsers: {
        type: Boolean,
        default: false,
    },
    requireSso: {
        type: Boolean,
        default: false,
    },
});

const showTabs = ref(false);
const currentTab = ref('active');

const activeUsersRef = ref(null);
const pendingUsersRef = ref(null);
const invitesCount = ref(0);

orgUnitInvitationsClient
    .invitationsCount(props.teamId, props.orgUnitId)
    .then(({ data }) => {
        invitesCount.value = data.count || 0;
        showTabs.value = invitesCount.value > 0;
    })
    .catch((e) => {
        console.error(e);
        toasted.global.platform_error();
    });

const onAdded = () => {
    if (currentTab.value === 'pending') {
        activeUsersRef?.value?.applyFilters();
    }
};

const onUpdated = () => {
    if (currentTab.value === 'pending') {
        activeUsersRef?.value?.applyFilters();
    }
};

const onInvited = () => {
    pendingUsersRef?.value?.loadData();
    invitesCount.value++;
    showTabs.value = true;
};

const onInviteDeleted = () => {
    invitesCount.value--;
    showTabs.value = invitesCount.value > 0;

    currentTab.value = showTabs.value ? 'pending' : 'active';
};
</script>
